export enum CoaHeaderEnum {
  HEADER = 1,
  SUB_HEADER = 2,
  DETAIL = 3,
}